import CryptoJS from 'crypto-js'

export default {
    // 随机生成指定数量的16进制key
    generatekey (num:number) {
        let library = '827;POIU0928++=='
        let key = ''
        for (var i = 0; i < num; i++) {
            let randomPoz = Math.floor(Math.random() * library.length)
            key += library.substring(randomPoz, randomPoz + 1)
        }
        return key
    },

    // 加密
    encrypt (word:string, keyStr?:string) {
        keyStr = keyStr || '827;POIU0928++==' // 判断是否存在ksy，不存在就用定义好的key
        var key = CryptoJS.enc.Utf8.parse(keyStr)
        var srcs = CryptoJS.enc.Utf8.parse(word)
        var encrypted = CryptoJS.AES.encrypt(srcs, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 })
        return encrypted.toString()
    },
    // 解密
    decrypt (word:string, keyStr?:string) {
        keyStr = keyStr || '827;POIU0928++=='
        var key = CryptoJS.enc.Utf8.parse(keyStr)
        var decrypt = CryptoJS.AES.decrypt(word, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 })
        return CryptoJS.enc.Utf8.stringify(decrypt).toString()
    }

}
